<template>
  <div id="eventbar" :style="!menudisplay ? 'width: calc(100% - 430px);  transition: .3s;' : 'width: calc(100% - 160px);  transition: .3s;'">
    <md-toolbar id="eventbar-toolbar" class="toolbar eventbar-toolbar" :class="$route.params.session_id ? 'dark-eventbar-toolbar': ''"> 
      <div v-if="currentEvent" class="eventbar-container">

        <swiper class="swiper" style="padding: 0 15px;" :options="swiperOption" v-if="routeName != 'login' && routeName != 'register' && routeName != 'forgot-password' && routeName != 'home'">

          <swiper-slide class="eventbar-session-card" v-for="item in currentSessions" :key="item.id + item.updateDate">

            <div class="eventbar-session-card-inner" @click="item.id == $route.params.session_id ? '' : $store.dispatch('joinSession', item.id)">

              <div class="session-left">                

                <div class="session-info">
                    <span style="color: #ff7511;" v-if="item.isLive == false"><img src="/static/menuicons/waiting-clock.svg" />{{ $t("sessions.waiting") }}</span>
                    <span style="color: #f22f2f;" v-if="item.isLive == true"><img src="/static/menuicons/video-cam.svg" />{{ $t("sessions.live") }} {{ item.showWatcherCount ? '('+item.watcherCount+')' : ''}}</span>
                    <span>● {{ moment(item.startDate.replace("Z", "")).fromNow() }}</span>
                </div>

                <div class="session-title">
                  <p>{{ item.title }}</p>
                </div>

              </div>

              <div class="session-right">

                <button :style="'background-color: ' + (item.id == $route.params.session_id ? '#8C929C;': currentEvent.color)">
                  <span v-if="$store.state.sessionLoadingID != item.id" > {{ $t("sessions.join") }} </span>
                  <span v-if="$store.state.sessionLoadingID == item.id"><i class="fa fa-spinner spin"></i></span>
                  <!-- <md-progress-spinner style="transition: 0s !important;" v-if="$store.state.sessionLoadingID == item.id" class="md-accent" :md-diameter="15" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner> -->
                </button>                

              </div>

            </div>

          </swiper-slide>

          <div slot="button-prev"></div>
          <div slot="button-next"></div>

        </swiper>
      </div>
    </md-toolbar>

    <md-snackbar class="warning" :md-position="'center'" :md-duration="4000" :md-active.sync="error.hasError" md-persistent>
      <i class="fa fa-exclamation-triangle"></i><span>{{ error.message }}</span>
    </md-snackbar>

  </div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import moment from "moment/min/moment-with-locales";
import $ from "jquery";
import _ from "lodash";
export default {
  name: "EventBar",
  components: {
    InfiniteLoading
  },
  props: {
    menudisplay: {
      type: Boolean,
      required: true,
      default: () => false,
    }
  },
  
  data() {
    return {
      tooltipActive: false,
      ok: true,
      moment,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: false
        }
      },
      routeName: this.$route.name,
      isOpen:
        localStorage.getItem("isOpen") == null
          ? true
          : localStorage.getItem("isOpen") == "true",
      localStorage,
      moment,
      message: null,
      error: {
        message: null,
        hasError: false
      },
      
    };
  },

  watch: {
    "$route.name": function() {
      this.routeName = this.$route.name;
      window.scrollTo(0, 0);
    }
  },

  mounted() {
    this.$nextTick(() => { 
      this.$store.dispatch("getSessions", { id: this.currentEvent.id, route: false });
    });
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentSessions() {
      return this.$store.getters.getSessions;
    },
  },

  // computed: {
  //   getCurrentSession() {
  //     if (this.routeName == "session") {
  //       return this.$store.state.sessions.find(
  //         k => k.id == this.$route.params.session_id
  //       );
  //     }
  //     return null;
  //   }
  // },
  // methods: {   
    
  //   getSession(id) {
  //     this.$store.dispatch("getSession", id); 
  //   },

  // }

};
</script>


<style lang="less">
#eventbar {
  position: fixed;
  height: 55px;
  width: 100%;
  z-index: 2;

  // &:hover {
  //   .eventbar-toolbar {
  //     margin-top: 0px;
  //     pointer-events: all;
  //   }
  // }
 
  .eventbar-toolbar {
    margin-top: -56px;
    min-height: 55px;
    transition: .3s;
    padding:0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: unset !important;
    background-color: #f1f3f6;
    border-bottom: unset !important;

    .eventbar-container {
      display: flex; 
      flex: 1;
      overflow: hidden; 
      height: 55px; 
      

      .eventbar-session-card {        
        width: auto;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 8px;
        margin-right: 8px;         

        .eventbar-session-card-inner {
          justify-content: space-around; 
          flex-direction: row; 
          align-items: center; 
          display: flex; 
          background-color: #fff;
          box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;
          border-radius: 8px;          
          padding: 4px 8px;

          &:hover {
            background-color: #f6f4f4;
            cursor: pointer;
          }  
          
          .session-left {
            display: flex;
            flex: 1;
            flex-direction: column;
            justify-content: center;
            color: white;
            margin-left: 10px;

            .session-info {
              margin:0px;
              span {
                color: #8C929C; 
                font-size: 12px;

                img {
                  width:12px; 
                  height:12px; 
                  margin-right:6px;
                }
              }
            }

            .session-title {
              line-height: 16px;

              p {
                text-overflow: ellipsis;
                max-width: 158px !important;
                white-space: nowrap;
                overflow: hidden;
                margin: 0px; 
                display: block;
                color: #292F3B;
                font-weight: 500;
                font-size: 14px;
              }
            }
          }

          .session-right {
            button {
              border: none;
              outline: none;
              padding: 8px 15px;
              background-color: whitesmoke;
              font-weight: bold;
              color: white;
              margin-left: 15px;
              border-radius: 16px;
              font-family: "Roboto";
              cursor: pointer;
            }
          }

        }
        
      }
    }
  }

  .dark-eventbar-toolbar {
    background-color: #292f3b !important;
    border-bottom: 0.5px solid #292f3b !important;

    .eventbar-session-card-inner {
      border: 1px solid #313744 !important;
      background-color: #292f3b !important;

      &:hover {
        background-color: rgba(51, 58, 72, 0.9);
      } 

      .session-title {        
        p {
          color: white !important;
        }
      }
    }
  }

  .acc-button .md-ripple .md-button-content {
    display: flex;
    align-items: center;
    flex-direction: row;
  }

}
.spin {
  -webkit-animation: fa-spin 2s infinite linear;
  animation: fa-spin 2s infinite linear;
}

</style>



// WEBPACK FOOTER //
// src/modules/EventBar.vue